import { render, staticRenderFns } from "./SearchButton.vue?vue&type=template&id=4dda5efe&scoped=true&"
import script from "./SearchButton.vue?vue&type=script&lang=js&"
export * from "./SearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda5efe",
  null
  
)

export default component.exports